import Overview from "./Overview";
import Form from "./SoftwareInfoForm";

export default { Form, Overview };
